
export enum MetricThresholdValueTypeCd {
	PCT = 'Pct',
	UOM = 'Uom'}

